/* eslint-disable import/no-named-as-default-member */
/* eslint-disable consistent-return */

import apolloClient from '../../../core/backendClient/apolloClient';
import Schemas from './graphql';

/**
 * @param {string} storeId
 * @returns {Promise<{ returnReasons, categories, storeConfigs }> | null>}
 */
async function getStoreConfigsAndRules(storeId) {
  const res = await apolloClient.query({
    query: Schemas.GET_STORE_CONFIGS_AND_RULES,
    variables: { storeId },
  });
  if (
    res.data.reasons.code === 200 &&
    res.data.categories.code === 200 &&
    res.data.storeConfigs.code === 200
  ) {
    return {
      returnReasons: res.data.reasons.returnReasons,
      categories: res.data.categories.orderItemCategories,
      storeConfigs: res.data.storeConfigs.storeConfigs,
    };
  }
  return null;
}

/**
 * @param {{ storeId, markIneligibleCategories, removeIneligibleCategories, returnReasons, updateStoreConfigs }} storeConfigsAndRules
 * @returns {Promise<null>}
 */
async function saveStoreConfigsAndRules({
  storeId,
  markIneligibleCategories,
  removeIneligibleCategories,
  returnReasons,
  updateStoreConfigs,
}) {
  const res = await apolloClient.mutate({
    mutation: Schemas.SAVE_STORE_CONFIG_AND_RULES,
    variables: {
      storeId,
      markIneligibleCategories,
      removeIneligibleCategories,
      returnReasons,
      updateStoreConfigs,
    },
  });
  if (
    res.data.setCategoriesAsIneligible.code === 200 &&
    res.data.removeCategoriesFromIneligible.code === 200 &&
    res.data.toggleReturnReasonSelection.code === 200 &&
    res.data.updateStoreConfigs.code === 200
  ) {
    return 'Configurações salvas com sucesso';
  }
  return null;
}

export default {
  getStoreConfigsAndRules,
  saveStoreConfigsAndRules,
};
